// src/window-api.js
export function exposeWindowAPI({ bootVenue, flowPanels }) {
  window.AttraxionBooking = window.AttraxionBooking || {
    async open({ venue, checkout, product, date, time } = {}) {
      if (!venue) throw new Error('AttraxionBooking.open: venue required');
      const entry = await bootVenue(venue, checkout);
      if (!entry) return; // silent bail
      entry.iframe.contentWindow?.postMessage({
        type: 'attraxion:deep-link', product, date, time,
      }, new URL(entry.iframe.src).origin);
      entry.panel.open();
    },
    close({ venue, checkout } = {}) {
      const key = checkout ? `${venue}:${checkout}` : venue;
      const e = flowPanels.get(key);
      e?.panel.close();
    },
  };
}
